import NeptuneElement from "../../NeptuneElement.js";

class TabPanel extends NeptuneElement {
    
    templateMarkup = `
        <div role="tabpanel" tabindex="-1" hidden aria-hidden="true">
            <slot></slot>
        </div>
    `;

    componentCssUrl = '/src/components/container/tabgroup/tab-panel.css';

    constructor() {
        super();
    }

    async connectedCallback() {
        await super.connectedCallback();
    }

    async disconnectedCallback() {
        await super.disconnectedCallback();
    }
}

customElements.define('neptune-tab-panel', TabPanel);
export default TabPanel;